var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconCheckbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7389 1.7412C11.4297 1.44192 10.9531 1.42207 10.6217 1.67651L10.5269 1.76107L4.29829 8.19714L1.48245 5.19475L1.38904 5.1087C1.06168 4.84904 0.584848 4.86135 0.270897 5.15569C-0.0430543 5.45003 -0.0860467 5.92508 0.151989 6.26848L0.231841 6.36724L3.66277 10.0267L3.7595 10.1154C4.06481 10.3552 4.49684 10.3587 4.8059 10.1237L4.90402 10.0366L11.7588 2.95321L11.8402 2.85573C12.0836 2.51614 12.0482 2.04047 11.7389 1.7412Z"
  })));
}
export default SvgCommonIconCheckbox;